import { IStyleSettings } from "@nsdefs";

export const defaultStyles: IStyleSettings = {
  lineHeight: 1.5,
  fontFamily: `JetBrainsMono, "Courier New", monospace`,
};
